import React from 'react';
import classnames from 'classnames';
import Loading from '@gp/components/Loading';
import SimpleRenameTitle from '@gp/components/SimpleRenameTitle';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

export interface IReportCardProps extends IBaseProps {
  // 模块key
  moduleKey?: string;
  // 标题
  title: string | React.ReactElement | null;
  // 是否支持修改标题
  isSupportRenameTitle?: boolean;
  onTitleChange?: (payload: string) => void;
  // 是否loading
  isLoading?: boolean;
  // 右上角插槽
  headerRight?: string | React.ReactElement | null;
  actions?: React.ReactElement | null;
}

const ReportCard: React.FC<IReportCardProps> = (props) => {
  const {
    style,
    className,
    moduleKey,
    title,
    isSupportRenameTitle = false,
    onTitleChange,
    isLoading = false,
    headerRight,
    actions,
    children,
  } = props;

  return (
    <article
      style={style}
      className={classnames('dbg-dps-report-card', className)}
      data-dps-report-module-key={moduleKey}
    >
      <header className="dbg-dps-report-card__header">
        <h2 className="dbg-dps-report-card__header-title">
          {isSupportRenameTitle && <SimpleRenameTitle value={title as string} onChange={onTitleChange} />}
          {isSupportRenameTitle || <span className="dbg-dps-report-card__header-title-text">{title}</span>}
        </h2>
        {!isLoading && !!headerRight && headerRight}
      </header>
      <main className={classnames('dbg-dps-report-card__body', { empty: !children, loading: isLoading })}>
        {isLoading && <Loading className="dbg-dps-report-card__loading" loading />}
        {!!actions && actions}
        {!isLoading && !!children && children}
      </main>
    </article>
  );
};

export default ReportCard;
